import type {
  ProductStoreRaw,
  CurbsideFlags,
  ProductStore,
} from "../types/bopis";

export const curbSideFlags = (store: ProductStoreRaw): CurbsideFlags => {
  const flags: CurbsideFlags = {};
  store.activeFeatureToggles?.BOPIS?.forEach((key: keyof CurbsideFlags) => {
    flags[key] = true;
  });
  return flags;
};

export const transformStoreList = (
  storeList: ProductStoreRaw[]
): ProductStore[] =>
  storeList.map((store: ProductStoreRaw) => ({
    activeFeatureToggles: curbSideFlags(store),
    storeName: store.storeName,
    storeAddress: {
      addressLine1: store.address.lines[0],
      cityName: store.address.city,
      stateProvinceCode: store.address.stateProvince,
      postalCode: store.address.postalCode,
      countryCode: store.address.countryCode,
      phoneNumber: store.phoneNumber,
    },
    storeHours: store.hours,
    storeDistance: store.distance,
    latitude: store.latitude,
    longitude: store.longitude,
    storeId: store.id,
    storeTimeZone: store.timeZone,
  }));
